<template>
  <div class="flex flex-col flex-grow bg-gray-50">
    <div class="container flex flex-col gap-1 flex-grow py-7 md:py-14">
      <slot />
    </div>
  </div>
</template>
